import {
    Component,
    computed,
    EventEmitter,
    inject,
    Input,
    Output,
    signal
} from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AppAvailableDatesSelectorComponent } from "@app/shared/components/app-dates-interval-selector/app-available-dates-selector.component";
import { PeriodNames } from "@arch/_shared/types/interval-dates";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import { CompanyEntity } from "@arch/domain/entity";
import { ScenarioEntity } from "@arch/domain/entity/scenario.entity";
import { GetAvailableController } from "@arch/presentation/controllers/get-available.controller";
import { EventChangePeriodParams } from "../report-toolbar/report-toolbar.component";
@Component({
    selector: "app-report-adjustments-period",
    imports: [FlexLayoutModule, AppAvailableDatesSelectorComponent],
    templateUrl: "./report-adjustments-period.component.html",
    styleUrl: "./report-adjustments-period.component.scss"
})
export class ReportAdjustmentsPeriodsComponent {
    @Input({ required: true }) company: CompanyEntity;
    @Input({ required: true }) scenarios: ScenarioEntity[];
    @Input({ required: false }) dropdownConfigs: {
        equalYear: boolean;
    };
    @Input({ required: true }) set options(value: VisualizationOptionsType) {
        this.optionsSignal.set(value);
    }
    get options() {
        return this.optionsSignal();
    }
    private optionsSignal = signal<VisualizationOptionsType>(null);
    @Output() handleChangePeriod = new EventEmitter<EventChangePeriodParams>();

    private readonly getAvailableController = inject(GetAvailableController);

    onApplyPeriod(event: {
        scenario: ScenarioEntity;
        periodName: PeriodNames;
        startDate: Date;
        endDate: Date;
    }) {
        this.handleChangePeriod.emit(event);
    }

    public readonly periodAvailable = computed((): Date[] => {
        if (!this.options) return null;
        const available = this.getAvailableController.execute({
            companyId: this.company.props._id,
            source: this.options.source,
            sources: this.options.sources,
            scenarioId: this.options.scenario.props._id,
            options: {
                budget: this.options.budget,
                projection: this.options.projection
            }
        });

        return available;
    });

    public onSelectScenarioPeriod(event: ScenarioEntity): void {
        this.optionsSignal.update((prev) => ({
            ...prev,
            scenario: event
        }));
    }
}
